module.exports = __webpack_public_path__ + "images/credit_cards.gif";